import { ReactNode } from 'react';
import Footer from '@framework/ui/Organisms/Filters/FiltersPanel/Footer';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { IMarketArticlesFilterPayload } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';
import { CFR_ARTICLES } from '@/creditflowresearch/ui/components/creditFlow/articles/FiltersButton/constants';
import {
  useArticlesFilterContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/Filter/ArticlesFilterContext';

type FilterValueType = number | null | boolean | string[];

interface ISidebarFooterProps {
  onApply: () => void,
  onReset: () => void,
  onTagRemove: (filterName:string, filterValue:FilterValueType) => void,
  className: string,
  tagsComponent: ReactNode,
}

const SidebarFooter = (props: ISidebarFooterProps) => {
  const { state: { appliedFilters, initialFilters } } = useArticlesFilterContext();
  const { getFilters } = useFiltersContext();
  const filters: IMarketArticlesFilterPayload = getFilters(CFR_ARTICLES);

  return (
    <Footer
      filters={ filters }
      appliedFilters={ appliedFilters }
      initialFilters={ initialFilters }
      { ...props }
    />
  );
};

export default SidebarFooter;
